module.exports = __webpack_public_path__ + "static/media/boleador_icon_b.f7788493.png";